<template>
  <div>
    <!-- 切换选项：二维表 / 列表输入，放数量前面，仅在可输入且无顶部数据时显示 -->
    <div v-if="isShowTotalNumber || (!readonly &&  !userHtml)"
         style="font-size:12pt;display:flex;align-items:center;">
      <span v-if="!readonly && !userHtml" style="white-space:nowrap;">
        <span :style="{cursor:'pointer',color:!listMode?'#409EFF':'#999',fontWeight:!listMode?'bold':'normal'}"
              @click="listMode && toggleViewMode()">二维表</span>
        <span style="color:#ccc;margin:0 3px;"> / </span>
        <span :style="{cursor:'pointer',color:listMode?'#409EFF':'#999',fontWeight:listMode?'bold':'normal'}"
              @click="!listMode && toggleViewMode()">列表输入</span>
      </span>
      <span style="flex:1;"></span>
      <span v-if="isShowTotalNumber" style="white-space:nowrap;">
        <span v-if="isshowprice&&price['单价']!=undefined">单价：{{price['单价']}}</span>&nbsp;<span>总数：{{totalnumber}} (片) </span>&nbsp;<span
        v-if="isshowprice&&price['总价']!=undefined"> 总价：{{price['总价']}}</span>
      </span>
    </div>
    <div v-show="!listMode">
      <el-table
        :data="showErweitable(true)" v-if="!userHtml&&needtwo"
        :height="geterwtableHeight()" border :header-cell-class-name="'twodimensionalcellheader'"
        :cell-class-name="cellClassName"
        size="mini"
        style="width: 48%;float: left;">
        <el-table-column
          width="48"
          label="球\柱"
          align="center">
          <template slot-scope="scope">
            {{(scope.row[0].Y > 0 ? "+" : "" ) + scope.row[0].Y.toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column v-for="(item,xindex) in zhujing" :key="item"
                         :label="(item > 0 ? '+' : '')+item.toFixed(2)"
                         align="right" :width="tdwidth" header-align="center">
          <template slot-scope="scope">
            <span v-if="(topInfoData&&topInfoData.length > 0)||topshowstring" :style="{backgroundColor:getTopInfoColor(scope.row[xindex])}" v-html="scope.row[xindex].TP==0?'':scope.row[xindex].TP" class="top-info"></span>
            <input :ref="('fl'+xindex+''+scope.$index)" :readonly="readonly" v-model="scope.row[xindex].P"
                   :title="'S：'+scope.row[xindex].Y.toFixed(2)+' ， C：'+scope.row[xindex].X.toFixed(2)"
                   onfocus="this.select()" @change="inputChange(scope.row[xindex])"
                   @keyup.enter.stop="opKeyEnter($event,xindex,scope.$index,'fl')"
                   @keyup.up.stop="opKeyUp($event,xindex,scope.$index,'fl')"
                   @keyup.down.stop="opKeyDown($event,xindex,scope.$index,'fl')"
                   @keyup.left.stop="opKeyLeft($event,xindex,scope.$index,'fl')"
                   @keyup.right.stop="opKeyRight($event,xindex,scope.$index,'fl')"/>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        :data="showErweitable(false)" v-if="!userHtml"
        :height="geterwtableHeight()" border :header-cell-class-name="'twodimensionalcellheader'"
        :cell-class-name="cellClassName"
        size="mini"
        :style="{width: needtwo?'48%':'100%'}" style="float: left;">
        <el-table-column
          width="48"
          label="球\柱"
          align="center">
          <template slot-scope="scope">
           {{(scope.row[0].Y > 0 ? "+" : "" ) + scope.row[0].Y.toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column v-for="(item,xindex) in zhujing" :key="item"
                         :label="(item > 0 ? '+' : '')+item.toFixed(2)"
                         align="right" :width="tdwidth" header-align="center">
          <template slot-scope="scope">
            <span v-if="(topInfoData&&topInfoData.length > 0)||topshowstring" :style="{backgroundColor:getTopInfoColor(scope.row[xindex])}" v-html="scope.row[xindex].TP==0?'':scope.row[xindex].TP" class="top-info"></span>
            <input :ref="('f'+xindex+''+scope.$index)" :readonly="readonly" v-model="scope.row[xindex].P"
                   :title="'S：'+scope.row[xindex].Y.toFixed(2)+' ， C：'+scope.row[xindex].X.toFixed(2)"
                   onfocus="this.select()" @change="inputChange(scope.row[xindex])"
                   @keyup.enter.stop="opKeyEnter($event,xindex,scope.$index)"
                   @keyup.up.stop="opKeyUp($event,xindex,scope.$index)"
                   @keyup.down.stop="opKeyDown($event,xindex,scope.$index)"
                   @keyup.left.stop="opKeyLeft($event,xindex,scope.$index)"
                   @keyup.right.stop="opKeyRight($event,xindex,scope.$index)"/>
          </template>
        </el-table-column>
      </el-table>
      <span v-if="userHtml" v-html="twodimenhtml"></span>
    </div>
    <div v-show="listMode">
      <el-table :data="listData" border size="mini" style="width:100%;"
        :max-height="getListTableHeight()"
        :row-style="{'height':'33px'}"
        :header-cell-style="{'background-color':'#fffdef','text-align':'center','font-size':'12px','padding':'3px 0','font-weight':'normal'}"
        :cell-style="{'padding':'1px 0','text-align':'center'}">
        <el-table-column label="球镜" width="150">
          <template slot-scope="scope">
            <input data-row="s"
              :data-col="scope.$index"
              v-model="listData[scope.$index].sphereStr"
              @focus="onListInputFocus($event)"
              @blur="onListSphereBlur(scope.$index)"
              @keydown="handleListKeydown($event, scope.$index, 'sphere')"
              class="list-input"/>
          </template>
        </el-table-column>
        <el-table-column label="柱镜" width="150">
          <template slot-scope="scope">
            <input data-row="c"
              :data-col="scope.$index"
              v-model="listData[scope.$index].cylinderStr"
              @focus="onListInputFocus($event)"
              @blur="onListCylinderBlur(scope.$index)"
              @keydown="handleListKeydown($event, scope.$index, 'cylinder')"
              class="list-input"/>
          </template>
        </el-table-column>
        <el-table-column label="数量" width="100">
          <template slot-scope="scope">
            <input data-row="q"
              :data-col="scope.$index"
              v-model="listData[scope.$index].quantityStr"
              @focus="onListInputFocus($event)"
              @blur="onListQuantityBlur(scope.$index)"
              @keydown="handleListKeydown($event, scope.$index, 'quantity')"
              class="list-input"/>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import {saveData, getDetail, getControlData} from '@/api/set/goodsprice';

  export default {
    name: "DataContactEdit",
    data() {
      return {
        defaultValue: "",
        fixed: true,
        needtwo:false,
        twodimenhtml: "",
        userHtml: false,
        zhujing: [],
        qiujing: [],
        book: {
          XStart: "",
          XEnd: "",
          XSpace: "",
          YStart: "",
          YEnd: "",
          YSpace: "",
          BookContent: []
        },
        placeHolderContent: [],//格式等同于book.BookContent, 也可以是一个字符串
        form: {  //表单数据

        },
        formLabelWidth: '120px',
        topInfoData: [],//传递的顶部分栏信息，例如库存， 格式 [{"X":1.5,"Y":3,"P":8},{}]
        listMode: false,
        listData: [],
        rules: {////////定义正则验证字段。

        },
      }
    },
    props: {
      topshowstring: {
        default: false,
      },
      needSetDisabled: {//是否需要设置某些单元格禁用，默认true。
        default: true
      },
      needSetUnion: {//是否根据联合光度和是否启用柱镜0.25禁用设置某些单元格禁用，默认false。在needSetDisabled=true时有效
        default: false
      },
      erweitable: {
        type: Array,
        default: () => []
      },
      tdwidth: {
        default: 40
      },
      cutHeight: {
        default: 245
      },
      needSetHeight: {
        default: true
      },
      readonly: {
        default: false
      },
      cannotempty: {//不能为空，当填写空时，自动变成0   2018-10-17
        default: false
      },
      isShowTotalNumber: {//是否显示总数，价格设置、最大最小库存设置时需要设置成false
        default: true
      },
      precision: {//精度
        default: 'none' //默认不考虑精度问题。 如果设置，则四舍五入，使用Math.round,不能使用toFixed
      },
      positive: {//只能输入正数
        default: false
      },
      isshowprice: {//是否显示价格
        default: false
      },
      isMakeInvent: {
        default: false
      },
      price: {}
    },
    methods: {
      //获取顶部的背景色
      getTopInfoColor(XY) {
        var theP=XY.P;
        var store=XY.TP;

        if(XY.color)
          return XY.color;

        if(parseFloat(theP || 0)==0&&parseFloat(store || 0)==0) {
          return '';
        }

        if(this.topshowstring) {
          if (store && store != '')
            return "#67C23A";
          else {
            return "";
          }
        }

        if(this.isMakeInvent) {
          if (parseFloat(theP || 0) > parseFloat(store || 0)) {//增加
            return "#67C23A";
          } else if (parseFloat(theP || 0) == parseFloat(store || 0)) {
            return "#409EFF";
          } else {
            return "#E6A23C";
          }
        }
        return parseFloat(theP || 0) > parseFloat(store || 0) ? "orangered" : "#8CB803"
      },
      showErweitable(plus) {
        if(!this.needtwo)
          return this.erweitable;
        const newTable = [];
        if (plus) {//只显示Y正数
          for (let i in this.erweitable) {
            if (this.erweitable[i].length == 0) continue;
            if (this.erweitable[i][0].Y > 0)
              newTable.splice(0,0,this.erweitable[i]);
          }
        } else {
          for (let i in this.erweitable) {
            if (this.erweitable[i].length == 0) continue;
            if (this.erweitable[i][0].Y <= 0)
              newTable.push(this.erweitable[i]);

          }
        }
        return newTable;
      },
      getXYString(value){
        return (parseFloat(value)>0?"+":"")+parseFloat(value).toFixed(2);
      },
      getExcel(title) {
        let header1 = ["球\\柱"]
        let column1 = [ "Y"]

        for(let i in this.zhujing){
          var name=this.getXYString(this.zhujing[i]);
          header1.push(name);
          column1.push(name);
        }
        var datas=[];
        for(let i in this.erweitable) {
          var row = this.erweitable[i];
          var newRow = {};
          for (let j in row) {
            if (j == 0)
              newRow.Y = this.getXYString(row[j].Y);
            newRow[this.getXYString(row[j].X)] = row[j].P ? row[j].P : '';
          }
          datas.push(newRow);
        }
        var biaoti = []
        this.$exportExcel(header1, column1, datas, title, biaoti);
      },
      opKeyUp(event, x, y,refpre) {
        if(!refpre) refpre='f';
        if (this.$refs[refpre + x + "" + (y - 1)])
          if (this.$refs[refpre + x + "" + (y - 1)][0].parentNode.parentNode.className.indexOf("twodimensionaldisabled") > -1) {
            this.opKeyUp(event, x, y - 1,refpre)
            return
          } else {
            this.$refs[refpre + x + "" + (y - 1)][0].focus()
          }
        else
          event.target.blur()
      },
      opKeyDown(event, x, y,refpre) {
        if(!refpre) refpre='f';
        if (this.$refs[refpre + x + "" + (y + 1)]) {
          if (this.$refs[refpre + x + "" + (y + 1)][0].parentNode.parentNode.className.indexOf("twodimensionaldisabled") > -1) {
            this.opKeyDown(event, x, y + 1,refpre)
            return
          } else {
            this.$refs[refpre + x + "" + (y + 1)][0].focus()
          }
        } else {
          event.target.blur()
        }
      },
      opKeyLeft(event, x, y,refpre) {
        if(!refpre) refpre='f';
        if (this.$refs[refpre + (x - 1) + "" + y]) {
          if (this.$refs[refpre + (x - 1) + "" + y][0].parentNode.parentNode.className.indexOf("twodimensionaldisabled") > -1) {
            this.opKeyLeft(event, x - 1, y,refpre)
            return
          } else {
            this.$refs[refpre + (x - 1) + "" + y][0].focus()
          }
        }
        else if (this.$refs[refpre + (this.zhujing.length - 1) + "" + (y - 1)]) {
          if (this.$refs[refpre + (this.zhujing.length - 1) + "" + (y - 1)][0].parentNode.parentNode.className.indexOf("twodimensionaldisabled") > -1) {
            this.opKeyLeft(event, this.zhujing.length - 1, y - 1,refpre)
            return
          } else {
            this.$refs[refpre + (this.zhujing.length - 1) + "" + (y - 1)][0].focus()
          }
        }
        else
          event.target.blur()
      },
      opKeyRight(event, x, y,refpre) {
        if(!refpre) refpre='f';
        if (this.$refs[refpre + (x + 1) + "" + y]) {
          if (this.$refs[refpre + (x + 1) + "" + y][0].parentNode.parentNode.className.indexOf("twodimensionaldisabled") > -1) {
            this.opKeyRight(event, x + 1, y,refpre)
            return
          } else {
            this.$refs[refpre + (x + 1) + "" + y][0].focus()
          }
        }
        else if (this.$refs[refpre+"0" + (y + 1)]) {
          if (this.$refs[refpre+"0" + (y + 1)][0].parentNode.parentNode.className.indexOf("twodimensionaldisabled") > -1) {
            this.opKeyRight(event, 0, y + 1,refpre)
            return
          } else {
            this.$refs[refpre+"0" + (y + 1)][0].focus()
          }
        }
        else
          event.target.blur()
      },
      opKeyEnter(event, x, y,refpre) {//触发enter事件
        this.opKeyRight(event, x, y,refpre)
      },
      inputChange(item) {//2018-10-17
        if (this.cannotempty && item.P == "") {
          item.P = 0
        } else if (this.precision != 'none' && this.precision >= 0) {
          item.P = (Math.round(parseFloat(item.P || 0) * Math.pow(10, this.precision || 0)) / Math.pow(10, this.precision || 0)).toFixed(this.precision || 0)
        }
        if(this.positive&&item.P&&item.P<0) {
          item.P = -item.P;
        }
        this.$emit("afterChange", item)
      },
      getDisabled(item) {//判断某项数据是否启用
        if (!this.needSetDisabled) {
          return false
        }
        if (this.needSetUnion) {//联合光度
          if ((this.book.DisabledX25 && Math.abs(item.X) == 0.25) || (this.book.DisabledY25 && Math.abs(item.Y) == 0.25)) {
            item.P = ""
            return true
          }
          if (this.book.Union) {
            if (item.Y < 0 && Math.abs(item.Y) + Math.abs(item.X) > Math.abs(this.book.Union)) {
              item.P = ""
              return true
            }
          }
          return false
        } else {
          let temp1 = this.book.BookContent.filter(item1 => {
            return item1.X == item.X && item1.Y == item.Y
          })
          let result = temp1.length == 0
          if (result) {
            item.P = ""
          }
          return result
        }
      },
      renderYdataWithInitData(i, initdata) {
        this.qiujing.push(i)
        let arr = []
        for (let j in this.zhujing) {
          var temp = initdata.filter((item) => {
            return item.X == this.zhujing[j] && item.Y == i;
          })
          var tempTop = this.topInfoData.filter((item) => {
            return item.X == this.zhujing[j] && item.Y == i;
          })
          var rows={
            P: temp.length > 0 ? temp[0].P : this.cannotempty ? 0 : "",
            X: this.zhujing[j],
            Y: i,
            TP: tempTop.length > 0 ? tempTop[0].P : 0
          };
          if(tempTop.length > 0&&tempTop[0].color){
            rows.color=tempTop[0].color;
          }
          arr.push(rows)
        }
        this.erweitable.push(arr)
      },
      renderYdata(i) {
        this.qiujing.push(i)
        let arr = []
        for (let j in this.zhujing) {
          var tempTop = this.topInfoData.filter((item) => {
            return item.X == this.zhujing[j] && item.Y == i;
          })
          var rows = {
            P: this.defaultValue, X: this.zhujing[j], Y: i,
            TP: tempTop.length > 0 ? tempTop[0].P : 0
          };
          if (tempTop.length > 0 && tempTop[0].color) {
            rows.color = tempTop[0].color;
          }
          arr.push(rows);
        }
        this.erweitable.push(arr)
      },
      cellClassName(data) {
        if (data.columnIndex == 0)
          return 'twodimensionalcellheader';
        if (this.getDisabled(data.row[data.columnIndex - 1]))
          return 'twodimensionalcelltd1 twodimensionaldisabled';//不允许填写
        else
          return 'twodimensionalcelltd1';
      },
      createbook(initdata) {
        //生成柱镜
        this.zhujing = []
        this.qiujing = []
        this.erweitable.splice(0, this.erweitable.length)
        if (this.book.XSpace <= 0 || this.book.YSpace <= 0) {//防止死循环
          this.$message({
            showClose: true,
            message: '光度间隔必须大于0',
            type: 'error'
          });
          return
        }
        if (this.book.XStart >= this.book.XEnd) {
          for (let i = this.book.XStart; i >= this.book.XEnd; i -= this.book.XSpace) {
            this.zhujing.push(i)
          }
        } else {
          for (let i = this.book.XStart; i <= this.book.XEnd; i += this.book.XSpace) {
            this.zhujing.push(i)
          }
        }
        this.fixed = this.zhujing.length > 10;

        var maxY = 0;
        if (initdata && initdata.length > 0) {
          if (this.book.YStart >= this.book.YEnd) {
            maxY = this.book.YStart;
            for (let i = this.book.YStart; i >= this.book.YEnd; i -= this.book.YSpace) {
              this.renderYdataWithInitData(i, initdata)
            }
          } else {
            maxY = this.book.YEnd;
            for (let i = this.book.YStart; i <= this.book.YEnd; i += this.book.YSpace) {
              this.renderYdataWithInitData(i, initdata)
            }
          }
        } else {
          if (this.book.YStart >= this.book.YEnd) {
            maxY = this.book.YStart;
            for (let i = this.book.YStart; i >= this.book.YEnd; i -= this.book.YSpace) {
              this.renderYdata(i)
            }
          } else {
            maxY = this.book.YEnd;
            for (let i = this.book.YStart; i <= this.book.YEnd; i += this.book.YSpace) {
              this.renderYdata(i)
            }
          }
        }
        this.needtwo = maxY > 0;

      },
      geterwtableHeight() {
        if (!this.needSetHeight) {
          return null
        }
        return this.dialogtableHeight(this.cutHeight);
      },
      //第一个参数表示初始化球镜柱镜范围等设置，第二个参数表示初始化二维表值（编辑时使用）,第三个参数表示每个单元格顶部显示的内容，例如当前库存信息， 第四个参数表示默认值,第四个参数表示给单元格设置的placeholder。
      initBook(initbook, bookContent, defaultValue, topInfoData, placeHolderContent) {
        this.userHtml = false;
        //清空列表数据防残留；视图模式保持全局缓存的选中状态（二维表/列表输入）
        this.listMode = this.getListModeCache();
        this.listData = [];
        if (this.listMode) {
          this.fillEmptyListRows();
        }
        if (typeof (initbook) == "undefined" || typeof(initbook.XStart) == "undefined") {
          this.initForm()
          return
        }
        this.defaultValue = defaultValue
        this.erweitable.splice(0, this.erweitable.length)
        if (initbook) {
          this.book = initbook
          if (typeof (this.book.BookContent) == "undefined" || this.book.BookContent == "") {
            this.book.BookContent = []
          }
          this.topInfoData = []
          for(let i in topInfoData) {
            if (topInfoData[i].P > 0 || topInfoData[i].P < 0) {
              this.topInfoData.push({
                X: parseFloat(topInfoData[i].X),
                Y: parseFloat(topInfoData[i].Y),
                P: parseFloat(topInfoData[i].P),
                color: topInfoData[i].color ? topInfoData[i].color : null
              });
            }
          }

          this.placeHolderContent = placeHolderContent  //可以是字符串，也可以是数组
          // 其中的initbook.BookContent 仅仅是为了后面判断某单元格是否只读使用。真正的赋值还是要在保存时从二维表获取。
          this.createbook(bookContent)
        }
      },
      getzhujing() {
        return this.zhujing;
      },
      getqiujing() {
        return this.qiujing;
      },
      //简化显示内容 initbook=XY的范围  bookContent=最终的内容
      initBookFix(bookContent) {
        this.userHtml = true;
        this.erweitable.splice(0, this.erweitable.length)
        //生成柱镜
        this.zhujing = []
        //生成球镜
        this.qiujing = []

        var qiujingArea = []
        for (var bookC in bookContent) {
          var XV = Number(bookContent[bookC].X);
          bookContent[bookC].X = XV;
          var YV = Number(bookContent[bookC].Y);
          bookContent[bookC].Y = YV;
          var temp = this.zhujing.filter((item) => {
            return item == XV;
          })
          if (temp.length == 0)
            this.zhujing.push(XV)

          temp = qiujingArea.filter((item) => {
            return item == YV;
          })
          if (temp.length == 0)
            qiujingArea.push(YV)
        }

        this.zhujing.sort(this.sequence);
        qiujingArea.sort(this.sequence);

        for (var i in qiujingArea) {
          this.renderYdataWithInitData(qiujingArea[i], bookContent)
        }

       this.concathtml();
      },
      concathtml() {
        var topleft = "border-top:1px solid #000000;border-left:1px solid #000000;";
        var right = "border-right:1px solid #000000;";
        var bottom = "border-bottom:1px solid #000000;";

        // 分离正球镜（>0）和负球镜（<=0）
        var qiuJingYS = [];   // 球镜>0
        var qiuJingJin = [];  // 球镜<=0
        for (var j = 0; j < this.qiujing.length; j++) {
          if (this.qiujing[j] > 0) {
            qiuJingYS.push(this.qiujing[j]);
          } else {
            qiuJingJin.push(this.qiujing[j]);
          }
        }
        // 正球镜从小到大排序
        qiuJingYS.sort(function(a, b) { return a - b; });

        this.twodimenhtml = '';

        // 先构建球镜>0的TABLE（放左边，从小到大排列）
        if (qiuJingYS.length > 0) {
          var HTML = "<table style='border-spacing:0px;text-align: center;float:left;margin-left: 20px;margin-top: 5px'><tr><td style='width:48px;" + topleft + "'>球\\柱</td>";
          for (var i = 0; i < this.zhujing.length; i++) {
            HTML += "<td style='width:40px;" + topleft + (i == this.zhujing.length - 1 ? right : '') + "'>" + (this.zhujing[i] > 0 ? "+" : "") + (this.zhujing[i].toFixed(2)) + "</td>";
          }
          HTML += "</tr>";

          for (var j = 0; j < qiuJingYS.length; j++) {
            // 查找当前正球镜在this.qiujing中的索引，以获取对应的erweitable行
            var qjIndex = this.qiujing.indexOf(qiuJingYS[j]);
            HTML += "<tr><td style='" + topleft + (j == qiuJingYS.length - 1 ? bottom : '') + "'>" + (qiuJingYS[j] > 0 ? "+" : "") + (qiuJingYS[j].toFixed(2)) + "</td>";
            for (var i = 0; i < this.zhujing.length; i++) {
              HTML += "<td style='" + topleft + (i == this.zhujing.length - 1 ? right : '') + (j == qiuJingYS.length - 1 ? bottom : '') + "'>" + (this.erweitable[qjIndex][i].P) + "</td>";
            }
            HTML += "</tr>";
          }
          this.twodimenhtml = HTML;
        }

        // 再构建球镜<=0的TABLE（放右边）
        if (qiuJingJin.length > 0) {
          var HTML = "<table style='border-spacing:0px;text-align: center;float:left;margin-left: 20px;margin-top: 5px'><tr><td style='width:48px;" + topleft + "'>球\\柱</td>";
          for (var i = 0; i < this.zhujing.length; i++) {
            HTML += "<td style='width:40px;" + topleft + (i == this.zhujing.length - 1 ? right : '') + "'>" + (this.zhujing[i] > 0 ? "+" : "") + (this.zhujing[i].toFixed(2)) + "</td>";
          }
          HTML += "</tr>";

          for (var j = 0; j < this.qiujing.length; j++) {
            if (this.qiujing[j] > 0) continue;
            HTML += "<tr><td style='" + topleft + (j == this.qiujing.length - 1 ? bottom : '') + "'>" + (this.qiujing[j] > 0 ? "+" : "") + (this.qiujing[j].toFixed(2)) + "</td>";
            for (var i = 0; i < this.zhujing.length; i++) {
              HTML += "<td style='" + topleft + (i == this.zhujing.length - 1 ? right : '') + (j == this.qiujing.length - 1 ? bottom : '') + "'>" + (this.erweitable[j][i].P) + "</td>";
            }
            HTML += "</tr>";
          }

          if (this.twodimenhtml === '') {
            this.twodimenhtml = HTML;
          } else {
            this.twodimenhtml += HTML;
          }
        }
      },
      initBookFullFix() {
        this.userHtml = true;
        this.concathtml();
      },
      sequence(a, b) {//从大到小排列
        if (a > b) {
          return -1;
        } else if (a < b) {
          return 1
        } else {
          return 0;
        }
      },
      initForm() {
        this.qiujing = []
        this.zhujing = []
        this.erweitable.splice(0, this.erweitable.length)
        this.topInfoData = []
        this.defaultValue = ""
        //清空列表数据防残留；视图模式保持全局缓存的选中状态（二维表/列表输入）
        this.listMode = this.getListModeCache()
        this.listData = []
        if (this.listMode) {
          this.fillEmptyListRows()
        }
      },
      // ========== 列表输入模式方法 ==========
      //全局缓存读取：二维表/列表输入 上次选中的模式
      getListModeCache() {
        try {
          return localStorage.getItem('hpapi_twodim_listmode') == '1';
        } catch (e) {
          return false;
        }
      },
      //全局缓存写入
      setListModeCache(v) {
        try {
          localStorage.setItem('hpapi_twodim_listmode', v ? '1' : '0');
        } catch (e) {}
      },
      //列表模式空行填充（默认10行可输入）
      fillEmptyListRows() {
        while (this.listData.length < 10) {
          this.listData.push({sphere: null, cylinder: null, quantity: null, sphereStr: '', cylinderStr: '', quantityStr: ''});
        }
      },
      toggleViewMode() {
        if (this.listMode) {
          this.convertListToErweitable();
          this.listMode = false;
        } else {
          this.convertErweitableToList();
          this.listMode = true;
          this.$nextTick(() => {
            const firstInput = document.querySelector('input[data-row="s"][data-col="0"]');
            if (firstInput) firstInput.focus();
          });
        }
        this.setListModeCache(this.listMode);
      },
      convertErweitableToList() {
        this.listData = [];
        for (let row of this.erweitable) {
          for (let cell of row) {
            if (cell.P !== undefined && cell.P !== null && cell.P !== '' && parseFloat(cell.P) > 0) {
              this.listData.push({
                sphere: cell.Y,
                cylinder: cell.X,
                quantity: parseInt(cell.P),
                sphereStr: (cell.Y > 0 ? '+' : '') + cell.Y.toFixed(2),
                cylinderStr: (cell.X > 0 ? '+' : '') + cell.X.toFixed(2),
                quantityStr: String(parseInt(cell.P)),
                syncedSphere: cell.Y,//记录已同步到二维表的光度，用于光度变更时定位旧单元格
                syncedCylinder: cell.X
              });
            }
          }
        }
        while (this.listData.length < 10) {
          this.listData.push({sphere: null, cylinder: null, quantity: null, sphereStr: '', cylinderStr: '', quantityStr: ''});
        }
      },
      convertListToErweitable() {
        for (let row of this.erweitable) {
          for (let cell of row) {
            cell.P = '';
          }
        }
        for (let item of this.listData) {
          if (item.quantity && item.quantity > 0 && item.sphere !== null && item.cylinder !== null) {
            for (let row of this.erweitable) {
              for (let cell of row) {
                if (Math.abs(cell.X - item.cylinder) < 0.001 && Math.abs(cell.Y - item.sphere) < 0.001) {
                  cell.P = item.quantity;
                  break;
                }
              }
            }
          }
        }
      },
      isValidGridCombo(sphere, cylinder) {
        for (let row of this.erweitable) {
          for (let cell of row) {
            if (Math.abs(cell.X - cylinder) < 0.001 && Math.abs(cell.Y - sphere) < 0.001) {
              return !this.getDisabled(cell);
            }
          }
        }
        return false;
      },
      autoDivideValue(val) {
        if (val >= 25 || val <= -25) {
          val = val / 100;
        }
        return val;
      },
      onListInputFocus(event) {
        const el = event.target;
        this.$nextTick(() => {
          el.select();
        });
      },
      onListSphereBlur(index) {
        let raw = this.listData[index].sphereStr;
        let val = parseFloat(raw);
        if (isNaN(val) || raw.trim() === '') {
          this.listData[index].sphereStr = '';
          this.listData[index].sphere = null;
        } else {
          val = this.autoDivideValue(val);
          val = Math.round(val * 100) / 100;
          // 校验球镜与已有柱镜的组合是否在有效范围内
          if (this.listData[index].cylinder !== null && !this.isValidGridCombo(val, this.listData[index].cylinder)) {
            this.listData[index].sphereStr = '';
            this.listData[index].sphere = null;
            this.$message.warning('该球镜/柱镜组合不在有效范围内');
          } else {
            this.listData[index].sphere = val;
            this.listData[index].sphereStr = val.toFixed(2);
            // 柱镜为空时自动填0
            if (this.listData[index].cylinder === null) {
              this.listData[index].cylinder = 0;
              this.listData[index].cylinderStr = '0.00';
              // 自动填0后校验组合
              if (!this.isValidGridCombo(val, 0)) {
                this.listData[index].sphere = null;
                this.listData[index].sphereStr = '';
                this.listData[index].cylinder = null;
                this.listData[index].cylinderStr = '';
                this.$message.warning('该球镜/柱镜组合不在有效范围内');
              }
            }
          }
        }
        this.syncListToErweitable(index);
        this.ensureListRows(index);
      },
      onListCylinderBlur(index) {
        let raw = this.listData[index].cylinderStr;
        let val = parseFloat(raw);
        if (isNaN(val) || raw.trim() === '') {
          this.listData[index].cylinderStr = '';
          this.listData[index].cylinder = null;
        } else {
          val = this.autoDivideValue(val);
          val = Math.round(val * 100) / 100;
          // 校验柱镜与已有球镜的组合是否在有效范围内
          if (this.listData[index].sphere !== null && !this.isValidGridCombo(this.listData[index].sphere, val)) {
            this.listData[index].cylinderStr = '';
            this.listData[index].cylinder = null;
            this.$message.warning('该球镜/柱镜组合不在有效范围内');
          } else {
            this.listData[index].cylinder = val;
            this.listData[index].cylinderStr = val.toFixed(2);
          }
        }
        this.syncListToErweitable(index);
        this.ensureListRows(index);
      },
      onListQuantityBlur(index) {
        let raw = this.listData[index].quantityStr;
        let val = parseInt(raw);
        if (isNaN(val) || raw.trim() === '') {
          this.listData[index].quantityStr = '';
          this.listData[index].quantity = null;
        } else {
          if (val < 0) val = 0;
          this.listData[index].quantity = val;
          this.listData[index].quantityStr = String(val);
          // 数量>0且球镜柱镜都有值时，检查重复
          if (val > 0 && this.listData[index].sphere !== null && this.listData[index].cylinder !== null) {
            const curSphere = this.listData[index].sphere;
            const curCylinder = this.listData[index].cylinder;
            for (let i = 0; i < this.listData.length; i++) {
              if (i === index) continue;
              const other = this.listData[i];
              if (other.sphere !== null && other.cylinder !== null &&
                  Math.abs(other.sphere - curSphere) < 0.001 &&
                  Math.abs(other.cylinder - curCylinder) < 0.001 &&
                  other.quantity && other.quantity > 0) {
                this.$message.warning('第' + (i + 1) + '行存在相同光度，已清空本行数据');
                // 清空当前行
                this.listData[index].sphere = null;
                this.listData[index].sphereStr = '';
                this.listData[index].cylinder = null;
                this.listData[index].cylinderStr = '';
                this.listData[index].quantity = null;
                this.listData[index].quantityStr = '';
                break;
              }
            }
          }
        }
        this.syncListToErweitable(index);
        this.ensureListRows(index);
      },
      syncListToErweitable(index) {
        let item = this.listData[index];
        let hasNew = item.quantity && item.quantity > 0 && item.sphere !== null && item.cylinder !== null;
        let newSphere = hasNew ? item.sphere : null;
        let newCylinder = hasNew ? item.cylinder : null;
        let oldSphere = (item.syncedSphere === undefined || item.syncedSphere === null) ? null : item.syncedSphere;
        let oldCylinder = (item.syncedCylinder === undefined || item.syncedCylinder === null) ? null : item.syncedCylinder;
        //判断光度是否相对上次同步发生了变更
        let samePosition = (oldSphere === null && newSphere === null) ||
          (oldSphere !== null && newSphere !== null &&
            Math.abs(oldSphere - newSphere) < 0.001 &&
            Math.abs(oldCylinder - newCylinder) < 0.001);
        //光度发生变更时，先清除二维表中旧单元格，避免残留旧数据
        if (!samePosition && oldSphere !== null && oldCylinder !== null) {
          for (let row of this.erweitable) {
            for (let cell of row) {
              if (Math.abs(cell.X - oldCylinder) < 0.001 && Math.abs(cell.Y - oldSphere) < 0.001) {
                cell.P = '';
                break;
              }
            }
          }
        }
        if (hasNew) {
          if (!this.isValidGridCombo(newSphere, newCylinder)) {
            //无效组合：若之前已同步过，则通知父组件移除旧行
            if (oldSphere !== null && oldCylinder !== null) {
              this.$emit("afterChange", {X: oldCylinder, Y: oldSphere, P: 0});
            }
            item.syncedSphere = null;
            item.syncedCylinder = null;
            return;
          }
          for (let row of this.erweitable) {
            for (let cell of row) {
              if (Math.abs(cell.X - newCylinder) < 0.001 && Math.abs(cell.Y - newSphere) < 0.001) {
                cell.P = item.quantity;
                if (!samePosition && oldSphere !== null && oldCylinder !== null) {
                  //光度变更：携带旧光度oldX/oldY，让父组件就地更新已有行而不是新增一行
                  this.$emit("afterChange", {X: cell.X, Y: cell.Y, P: cell.P, oldX: oldCylinder, oldY: oldSphere});
                } else {
                  this.$emit("afterChange", cell);
                }
                item.syncedSphere = newSphere;
                item.syncedCylinder = newCylinder;
                return;
              }
            }
          }
        } else if (oldSphere !== null && oldCylinder !== null) {
          //数量清空或光度不完整：通知父组件移除旧行
          this.$emit("afterChange", {X: oldCylinder, Y: oldSphere, P: 0});
        }
        item.syncedSphere = null;
        item.syncedCylinder = null;
      },
      ensureListRows(editedIndex) {
        let len = this.listData.length;
        if (len === 0) return;
        let lastRow = this.listData[len - 1];
        if (lastRow && lastRow.quantityStr && lastRow.quantityStr !== '') {
          this.listData.push({sphere: null, cylinder: null, quantity: null, sphereStr: '', cylinderStr: '', quantityStr: ''});
        }
      },
      handleListKeydown(event, rowIndex, field) {
        const fields = ['sphere', 'cylinder', 'quantity'];
        const letters = ['s', 'c', 'q'];
        const idx = fields.indexOf(field);
        const moveTo = (targetRow, letter) => {
          if (targetRow < 0) return;
          this.$nextTick(() => {
            const selector = 'input[data-row="' + letter + '"][data-col="' + targetRow + '"]';
            const el = document.querySelector(selector);
            if (el) el.focus();
          });
        };
        const ensureRows = (minRow) => {
          while (this.listData.length <= minRow) {
            this.listData.push({sphere: null, cylinder: null, quantity: null, sphereStr: '', cylinderStr: '', quantityStr: ''});
          }
        };
        switch (event.key) {
          case 'Enter':
          case 'ArrowDown':
            event.preventDefault();
            ensureRows(rowIndex + 1);
            moveTo(rowIndex + 1, letters[idx]);
            break;
          case 'ArrowUp':
            event.preventDefault();
            if (rowIndex > 0) moveTo(rowIndex - 1, letters[idx]);
            break;
          case 'ArrowRight':
            event.preventDefault();
            if (idx < 2) {
              moveTo(rowIndex, letters[idx + 1]);
            } else {
              ensureRows(rowIndex + 1);
              moveTo(rowIndex + 1, 's');
            }
            break;
          case 'ArrowLeft':
            event.preventDefault();
            if (idx > 0) {
              moveTo(rowIndex, letters[idx - 1]);
            } else {
              if (rowIndex > 0) moveTo(rowIndex - 1, 'q');
            }
            break;
          case 'Tab':
            event.preventDefault();
            if (event.shiftKey) {
              if (idx > 0) {
                moveTo(rowIndex, letters[idx - 1]);
              } else {
                if (rowIndex > 0) moveTo(rowIndex - 1, 'q');
              }
            } else {
              if (idx < 2) {
                moveTo(rowIndex, letters[idx + 1]);
              } else {
                ensureRows(rowIndex + 1);
                moveTo(rowIndex + 1, 's');
              }
            }
            break;
        }
      },
      getListTableHeight() {
        if (!this.needSetHeight) return null;
        return this.dialogtableHeight(this.cutHeight);
      }
    },
    computed: {
      totalnumber() {
        let s = 0;
        if (this.listMode) {
          for (let item of this.listData) {
            if (item.quantity && item.quantity > 0) s += item.quantity;
          }
        } else {
          this.erweitable.forEach(o => {
            o.forEach(o2 => {
              if (o2.P)
                s += parseFloat(o2.P)
            })
          })
        }
        this.$emit("num", s)
        return s
      }
    },
    mounted() {
      //恢复全局缓存的视图模式（二维表/列表输入上次选中状态）
      this.listMode = this.getListModeCache();
      if (this.listMode && (!this.listData || this.listData.length === 0)) {
        this.fillEmptyListRows();
      }
    },
    components: {},
  }
</script>

<style scoped>
  .erweitable td {
    border: 1px solid #000000;
    min-width: 50px;
    max-width: 100px;
    text-align: center;
    vertical-align: center;
  }

  .erweitable .content {
    border: none;
    padding: 1px;
  }

  .top-info {
    font-size: 12px;
    display: inline-block;
    width: 100%;
    text-align: center;
    line-height: 12px;
    height: 12px;
    float: left;
  }
</style>

<style>
  .twodimensionalcelltd1 {
    border: 1px solid #000000; /*边框颜色*/
    padding: 1px 0 !important;
    font-weight: normal;
  }

  .twodimensionaldisabled {
    background-color: #e9e9e9;
  }

  .twodimensionaldisabled input {
    display: none;
  }

  .twodimensionaldisabled .top-info {
    display: none;
  }

  .twodimensionalcelltd1 input {
    width: 94%;
    border: 0px;
    text-align: center;
    height: 23px;
    font-size: 12px;
    font-weight: normal;
    background-color: transparent;
  }

  .twodimensionalcellheader {
    border: 1px solid #000000; /*边框颜色*/
    background-color: #fffdef !important;
    padding: 3px 0 !important;
    font-weight: normal;
    font-size: 12px;
  }

  .twodimensionalcelltd1 .cell, .twodimensionalcellheader .cell {
    padding-left: 3px !important;
    padding-right: 3px !important;
  }

  .list-input {
    width: 90%;
    border: 0px;
    text-align: center;
    height: 23px;
    font-size: 12px;
    font-weight: normal;
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/goodsprice/TwoDimensionalTable.vue